"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _Spinner = require("./Spinner.styles");

var Spinner = function Spinner(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_Spinner.StyledSpinnerWrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_Spinner.StyledSpinnerContainer, {
    role: "presentation"
  }, /*#__PURE__*/_react["default"].createElement(_Spinner.StyledSpinnerInnerContainer, {
    role: "presentation"
  }, /*#__PURE__*/_react["default"].createElement(_Spinner.StyledSpinner, {
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "5"
  })))));
};

Spinner.defaultProps = {
  className: ''
};
Spinner.propTypes = {
  /** Custom class to be added to the spinner container */
  className: _propTypes.string
};
Spinner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Spinner",
  "props": {
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Custom class to be added to the spinner container",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = Spinner;
exports["default"] = _default;